import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

// Components
import AboutUs from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Dishes from "./components/FoodDisplay";
import CookingItemDetail from "./components/CookingItemDetail";
import BottomNav from "./components/BottomNav";
import HomeCategorySlider from "./components/HomeCategorySlider";
import CheckoutPage from "./components/CheckoutPage";
import PaymentPage from "./components/PaymentPage";
import PaymentCallback from "./components/PaymentCallback"; // ✅ CALLBACK UI
import CredentialsModal from "./components/CredentialsModal";
import FAQ from "./components/FAQ";
import { useMyContext } from "./Context/MyContext";

// Admin / Inventory pages (added routes)
import InventoryPage from "./components/InventoryPage";
import EditProduct from "./components/EditProduct";

// ✅ ADD THIS: public shareable product detail page
import PublicItemDetail from "./components/PublicItemDetail";

function App() {
  const { showCredentialsModal, newAccount, closeCredentialsModal } =
    useMyContext();

  const handleBottomNavClick = (tab) => {
    console.log("Navigating to:", tab);

    const sectionMap = {
      category: "cookingitems",
      preorder: "orders",
      available: "services",
      wishlist: "testimonials",
      faq: "faq",
    };

    const sectionId = sectionMap[tab];
    if (sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        window.scrollTo({
          top: section.offsetTop - 80,
          behavior: "smooth",
        });
      }
    }
  };

  return (
    <Router>
      {/* ✅ Navbar stays persistent */}
      <Navbar />

      <Routes>
        {/* ================= HOME ================= */}
        <Route
          path="/"
          element={
            <div className="bg-purple-100 pt-28 md:pt-28 pb-20">
              <Hero />
              <HomeCategorySlider />
              <Dishes />
              <AboutUs />

              {/* ✅ FAQ Section */}
              <section id="faq">
                <FAQ />
              </section>

              <Contact />
              <Footer />
            </div>
          }
        />

        {/* ================= PRODUCT ================= */}
        {/* ✅ This is the PUBLIC shareable product detail page */}
        <Route path="/item/:id" element={<PublicItemDetail />} />

        {/* ⚠️ If you still need your old CookingItemDetail for internal use,
            change its path so they don't conflict: */}
        <Route path="/product/:itemId" element={<CookingItemDetail />} />

        {/* ================= CHECKOUT ================= */}
        <Route path="/checkout" element={<CheckoutPage />} />

        {/* ================= PAYMENT ================= */}
        <Route path="/payment" element={<PaymentPage />} />

        {/* ================= SQUAD CALLBACK (IMPORTANT) ================= */}
        <Route path="/payment/callback" element={<PaymentCallback />} />

        {/* ================= TEMPORARY TEST ROUTE ================= */}
        {/* Open this in browser to test PaymentCallback without a real payment */}
        <Route path="/payment/callback/test" element={<PaymentCallback />} />

        {/* ================= INVENTORY & ADMIN ROUTES ================= */}
        {/* Inventory listing page */}
        <Route path="/inventory" element={<InventoryPage />} />

        {/* Edit product page (used by InventoryPage edit button) */}
        <Route path="/admin/edit-product/:id" element={<EditProduct />} />
      </Routes>

      {/* ✅ Bottom navigation */}
      <BottomNav onNavigate={handleBottomNavClick} />

      {/* ================= CREDENTIALS MODAL ================= */}
      <CredentialsModal
        show={showCredentialsModal}
        email={newAccount?.email}
        password={newAccount?.password}
        onClose={closeCredentialsModal}
        onContinue={() => {
          closeCredentialsModal();
          window.location.href = "/checkout";
        }}
      />
    </Router>
  );
}

export default App;
